"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementManageState_1 = require("@/room/settlement_manage/settlementManageState");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const material_ui_confirm_1 = require("material-ui-confirm");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const __1 = require("..");
const _1 = require(".");
function default_1({ roomId }) {
    const setSettlementTotalAmount = (0, recoil_1.useSetRecoilState)(settlementManageState_1.settlementTotalAmountState);
    const setSettlementDetailsData = (0, recoil_1.useSetRecoilState)(settlementManageState_1.settlementDetailsDataState);
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const getSettlementDetailsData = () => __awaiter(this, void 0, void 0, function* () {
        yield (0, api_1.getData)(`/api/v1/room/${roomId}/settlement-manage`)
            .then(res => {
            const { result } = res.data;
            const { total_withdrawable_amount, total_reward_amount } = result;
            setSettlementTotalAmount({ total_withdrawable_amount, total_reward_amount });
            setSettlementDetailsData(result);
        })
            .catch(err => {
            var _a, _b;
            const { status } = err.response;
            if (((_b = (_a = err.response.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.alert_type) === 40302) {
                (0, errors_1.notFoundConfirm)({ confirm, isForm: true });
            }
            else if (status === 403)
                (0, errors_1.handle403Error)(err);
            else
                alert((0, errors_1.commonErrorMsg)(status));
        });
    });
    (0, react_1.useEffect)(() => {
        getSettlementDetailsData();
    }, []);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white", css: {
            display: 'flex',
            flexDirection: maxWidth768 ? 'column' : 'row',
            gap: '10px 24px',
            padding: maxWidth768 ? '10px 16px 0' : 0,
        } }, { children: [!maxWidth768 && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '12px', width: '300px' } }, { children: [(0, jsx_runtime_1.jsx)(__1.SettlementRequirements, {}), (0, jsx_runtime_1.jsx)(_1.SettlementGuide, {})] }))), maxWidth768 && (0, jsx_runtime_1.jsx)(_1.SettlementGuide, {}), (0, jsx_runtime_1.jsx)(_1.SettlementList, {})] })));
}
exports.default = default_1;
